<template>
  <SelectInput
    :error="errorMsg"
    :label="label"
    :model-value="modelValue"
    :placeholder="placeholder"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <option v-for="{ countryName, countryShortCode } in sortedCountries" :key="countryShortCode" :value="countryName">
      {{ countryName }}
    </option>
  </SelectInput>
</template>

<script setup lang="ts">
import { SelectInput } from '@ramp106/omrjs-core-ui/deprecated'
import type { BaseValidation } from '@vuelidate/core'
import { computed } from 'vue'

import countries from '~/countries'

interface CountrySelectEmits {
  (e: 'update:modelValue', value: string): void
}

interface CountrySelectProps {
  validation: BaseValidation
  placeholder?: string
  label?: string
  modelValue?: string
  topCountry?: string
}

defineEmits<CountrySelectEmits>()

const props = defineProps<CountrySelectProps>()

const sortedCountries = computed(() => {
  if (!props.topCountry) {
    return countries
  }

  return countries.sort((countryA, countryB) => {
    const { countryShortCode: countryAShortCode } = countryA
    const { countryShortCode: countryBShortCode } = countryB

    if (countryAShortCode === props.topCountry) {
      return -1
    }

    if (countryBShortCode === props.topCountry) {
      return 1
    }

    return 0
  })
})

const errorMsg = computed(() => props.validation.$errors.map((error) => error.$message).join(', '))
</script>
